// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"Loading_loadingScreen__3fq-s","loadingAnimate":"Loading_loadingAnimate__2Cacx"};